"use client";

import { Separator } from "@fm/ui";
import GoogleMap from "./GoogleMap";

// Mock coordinates for Chicago
const MOCK_LATITUDE = 41.8781;
const MOCK_LONGITUDE = -87.6298;

interface VehicleLocationProps {
  apiKey?: string;
  center?: { lat: number; lng: number };
  address?: string;
}

export function VehicleLocation({
  apiKey = "",
  center,
  address,
}: VehicleLocationProps) {
  return (
    <div className="pt-8 pb-0">
      <Separator className="mb-8" />

      <div>
        <h2 className="text-2xl font-semibold mb-2 text-[#020817]">
          RV Location
        </h2>
        <p className="text-sm text-[#64748B] mb-4">
          Exact location information is provided after a booking is confirmed.
        </p>

        {/* Map Container */}
        <div className="w-full rounded-xl overflow-hidden">
          <GoogleMap
            apiKey={apiKey}
            center={center}
            address={address}
            height="320px"
          />
        </div>
      </div>

      <Separator className="mt-8" />
    </div>
  );
}
